
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-factory-for-polyfill/-embroider-implicit-modules.js";
